import React from "react";
import _ from "lodash";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

function SubscribeNowButton(props) {
  // 1. Perustarkistus: Jos käyttäjä ei ole kirjautunut tai data puuttuu
  if (!props.isAuthed || _.isEmpty(props.user)) return null;

  const { user, locale, buttons, subscribe, redeemCode } = props;

  // 2. TARKISTUS: Käytetään tietokannan account.subscription -kenttää.
  // Huomioidaan myös trialing-tila Stripe-infosta varmuuden vuoksi, 
  // jos DB-päivitys on hitaampi.
  const hasActiveSubscription = user.account?.subscription === true;
  const isTrialing = user.stripeInfo?.status === "trialing";

  // 3. Jos tilaus on voimassa, näytetään infolaatikko painikkeiden sijaan
  if (hasActiveSubscription || isTrialing) {
    return (
      <div className="notification is-light is-info" style={{ padding: '0.75rem 1.25rem' }}>
        <span className="icon has-text-info" style={{ marginRight: '5px' }}>
          <i className="fas fa-check-circle"></i>
        </span>
        <strong>
          {isTrialing ? "Kokeilujakso on voimassa" : "Tilaus on voimassa"}
        </strong>
      </div>
    );
  }

  // 4. Jos tilausta ei ole, näytetään painikkeet
  return (
    <div className="buttons">
      {subscribe && (
        <Link
          to={"/userhome/user_account/subscription"}
          className="button is-link"
        >
          <span className="icon">
            <i className={buttons.subscribeNow.icon} />
          </span>
          <span>{buttons.subscribeNow[locale]}</span>
        </Link>
      )}
      {redeemCode && (
        <Link
          to={"/userhome/user_account/redeem_code"}
          className="button is-link"
        >
          <span className="icon">
            <i className={buttons.redeemCode.icon} />
          </span>
          <span>{buttons.redeemCode[locale]}</span>
        </Link>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  // Lisätty enemmän suojauksia polkuihin
  return {
    user: state.reducers?.auth?.user || {},
    isAuthed: state.reducers?.auth?.isAuthenticated || false,
    locale: state.intl?.locale || "fi",
    buttons: state.intl?.messages?.components?.buttons?.common || {
      subscribeNow: { icon: "fas fa-credit-card", fi: "Tilaa nyt" },
      redeemCode: { icon: "fas fa-tag", fi: "Käytä koodi" }
    },
  };
};

export default connect(mapStateToProps)(SubscribeNowButton);